module.exports = __webpack_public_path__ + "img/cpal.3451537b.png";